import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Process from "./components/Process";
import WhyUs from "./components/WhyUs";
import Reviews from "./components/Reviews";
import Inventory from "./components/Inventory";
import Contact from "./components/Contact";
import PayPage from "./components/PayPage";

const Home = () => (
  <div className="bg-app min-h-screen">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <Process />
      <WhyUs />
      <Reviews />
      <Inventory />
      <Contact />
    </main>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pay" element={<PayPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
